
export const AppMessages = {
  noDriverScore: "Not enough miles driven to receive a score for the current time period.",
  noOrganizationScore: "No drivers with enough miles driven to receive a score for the current time period.",
  noOffendingDrivers: 'Congratulations on your outstanding driver management!  Your team had no severe issues!',
  noMissedAcknowledgments: 'No Missed Acknowledgments',
  noIncidents: 'Congratulations!  You had no severe issues last period!',
  missingIncidentDetails: 'Details missing for one or more incidents.',
  confirmAcknowledgment: 'We appreciate your commitment to safety and efficiency. \r\nBy clicking below, you are acknowledging that you have reviewed your driver scorecard. If you have any questions about your score, please contact your supervisor.',
  streaksTitle: 'Streaks (days)',
  streakLongest: 'Longest',
  streakCurrent: 'Current',
  streakDaysUnit: 'days',
  streakUntitled: 'Streak',
  topStreaksTitle: 'Top Streaks (Days)',
  topStreakNoHolder: 'No streak holder yet',
  topStreaksEmpty: 'No drivers have earned a streak for these rules yet.',
};